import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { formatNumber, getSortIndicator } from '../../../../../utils/helpers';
import useSortedData from '../../../hooks/useSortedData';
import usePagination from '../../../hooks/usePagination';
import './PlayerPicker.css';

const ITEMS_PER_PAGE = 25;

const PlayerPickerSnake = ({ players, onStagePlayer, stagedPlayer, disabled }) => {
  const { sortedData: sortedPlayers, requestSort, sortConfig } = useSortedData(
    players,
    'sportSpecificData.icmValue',
    'descending'
  );

  const {
    currentItems,
    nextPage,
    prevPage,
    currentPage,
    maxPage,
    resetPage,
  } = usePagination(sortedPlayers, ITEMS_PER_PAGE);

  useEffect(() => {
    resetPage();
  }, [sortConfig, resetPage]);

  const handleStagePlayer = (player) => {
    if (disabled) return;
    onStagePlayer(player);
  };

  return (
    <div className="player-picker-container">
      <div className="player-picker-table-header">
        <span className="player-picker-table-header-text">
          AVAILABLE PLAYERS
        </span>
      </div>
      <table className="player-picker-table">
        <thead>
          <tr>
            <th onClick={() => requestSort('name')}>
              NAME {getSortIndicator(sortConfig, 'name')}
            </th>
            <th onClick={() => requestSort('sportSpecificData.chipCount')}>
              CHIPS {getSortIndicator(sortConfig, 'sportSpecificData.chipCount')}
            </th>
            <th onClick={() => requestSort('sportSpecificData.icmValue')}>
              ICM VALUE {getSortIndicator(sortConfig, 'sportSpecificData.icmValue')}
            </th>
          </tr>
        </thead>
        <tbody>
          {currentItems.map((player) => (
            <tr 
              key={player.name} 
              className={`player-row ${stagedPlayer?.name === player.name ? 'staged' : ''} ${disabled ? 'disabled' : ''}`}
              onClick={() => handleStagePlayer(player)}
            >
              <td>{player.name}</td>
              <td>{formatNumber(player.sportSpecificData?.chipCount)}</td>
              <td>${formatNumber(player.sportSpecificData?.icmValue)}</td>
            </tr>
          ))}
        </tbody>
      </table>
      {players.length > ITEMS_PER_PAGE && (
        <div className="pagination-controls">
          <button onClick={prevPage} className="pagination-btn" disabled={currentPage === 1}>
            &lt; Prev
          </button>
          <span className="pagination-info">
            Page {currentPage} of {maxPage}
          </span>
          <button onClick={nextPage} className="pagination-btn" disabled={currentPage === maxPage}>
            Next &gt;
          </button>
        </div>
      )}
    </div>
  );
};

PlayerPickerSnake.propTypes = {
  players: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    sportSpecificData: PropTypes.shape({
      chipCount: PropTypes.number,
      icmValue: PropTypes.number,
    })
  })).isRequired,
  onStagePlayer: PropTypes.func.isRequired,
  stagedPlayer: PropTypes.shape({
    name: PropTypes.string,
  }),
  disabled: PropTypes.bool,
};

PlayerPickerSnake.defaultProps = {
  disabled: false,
  stagedPlayer: null,
};

export default PlayerPickerSnake;
